import * as Schema from "effect/Schema";
import * as Rpc from "effect/unstable/rpc/Rpc";
import * as RpcGroup from "effect/unstable/rpc/RpcGroup";
import { EnvironmentAuthorizationError } from "./auth.ts";

const Key = Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(256));
export const WorldWatchInput = Schema.Union([
  Schema.Struct({
    kind: Schema.Literal("context"),
    coordinates: Schema.Array(
      Schema.Struct({ worldKey: Key, roomId: Key, sessionId: Schema.optionalKey(Key) }),
    ).check(Schema.isMinLength(1), Schema.isMaxLength(64)),
  }),
  Schema.Struct({
    kind: Schema.Literal("notifications"),
    worldKeys: Schema.Array(Key).check(Schema.isMinLength(1), Schema.isMaxLength(64)),
  }),
  Schema.Struct({ kind: Schema.Literal("native-runs"), worldKey: Key, sessionId: Key }),
  Schema.Struct({
    kind: Schema.Literal("canvas-data"),
    worldKey: Key,
    canvasId: Key,
    state: Schema.optionalKey(Schema.Record(Schema.String, Schema.Unknown)),
    sequence: Schema.Number.check(Schema.isInt(), Schema.isGreaterThanOrEqualTo(1)),
  }),
  // CVC2: one open Canvas face, one indexed head row, no content.
  Schema.Struct({ kind: Schema.Literal("canvas"), worldKey: Key, canvasId: Key }),
]);
export type WorldWatchInput = typeof WorldWatchInput.Type;
export class WorldWatchError extends Schema.TaggedErrorClass<WorldWatchError>()("WorldWatchError", {
  message: Schema.String,
}) {}
export const WORLD_WATCH_RPC = "neucleos.watchWorldState";
export const WorldWatchRpcGroup = RpcGroup.make(
  Rpc.make(WORLD_WATCH_RPC, {
    payload: WorldWatchInput,
    // Existing consumers validate each small NDJSON event. The same bytes ride
    // the established RPC socket instead of occupying a persistent HTTP slot.
    success: Schema.String,
    error: Schema.Union([WorldWatchError, EnvironmentAuthorizationError]),
    stream: true,
  }),
);
